// const BASE_URL = 'http://localhost:5000/api/v1';

const BASE_URL = 'https://astrologicalsolutions.astrologicalsolutions.in/api/v1';
export default BASE_URL;
export const API_URL = BASE_URL;
export const API = BASE_URL;



// https://astrologicalsolutions.astrologicalsolutions.in/postman/index.html